
import { useEffect, useState  } from 'react';
import { useDispatch, useSelector} from 'react-redux'
import ClientSwitch from './app/ClientSwitch';
import SetupForDrn from './app/SetupForDrn';
import { gettoken } from './app/slice/mainslice'


import { createStyles,
         Alert, 
         Group, 
         Container,
         Loader,
        } from '@mantine/core';

import { InfoCircle  } from 'tabler-icons-react';

import intl from 'react-intl-universal';
import deDE from './app/locales/de_DE.json'
import enUS from './app/locales/en_US.json'

const LOCALES_LIST = [
  {
    label: "DE",
    value: "de-DE",
  },
  {
    label: "EN",
    value: "en_US",
  },
];

const LOCALE_DATA = {
  "de_DE": deDE,
  "en_US": enUS,
}

const useStyles = createStyles((theme) => ({
  vcenter: {
    marginTop: '40vh',
    textAlign: 'center',
    marginLeft:'40%',
    maxWidth:'20%',
  },
  vcenter1: {
    marginTop: '35vh',
    textAlign: 'center',
    marginLeft:'40%',
    maxWidth:'20%',
  },
}));


/**
 * Generate a React functional component for the main App.
 *
 * @return {JSX.Element} The main App component
 */
function App() {
  const dispatch = useDispatch()
  const { classes } = useStyles();
  const signalrconnected = useSelector((state: any) => state.user.connected)
  const signalrerror = useSelector((state: any) => state.user.wsconnectederror)
  let currentLocale = useSelector((state: any) => state.user.clientlanguage)
  const [initDone, setInitDone] = useState(false);
  const icon = <InfoCircle />;

  const iskicked = useSelector((state: any) => state.user.iskicked)


 // Check if Setup is in url 
 let  urlElementstest = window.location.href 
 const isSetup = urlElementstest.includes("/setup");
 

 // Get Token Parameter from iframe url
  let urlElements = window.location.search.substring(1) 
 
  let tokenarray = urlElements.split('&')
  let token:any
  let meetingid: number
    if (tokenarray.length > 1){
      let tokenpara = tokenarray[0].split('=')
      token = tokenpara[1]
      let meetingidpara = tokenarray[1].split('=')
      meetingid = parseInt(meetingidpara[1])
    }


 
  useEffect(() => {
     if (!signalrconnected){
     // Connect to SignalR hub
      dispatch({ type: 'SIGNALR_CONNECT', token: token });
     }
      
     if (signalrconnected){
        // Token ist ok save in store
        dispatch(gettoken(token));
       
        const payload = {
          meetingId: meetingid,
        };
        // Request Startmeeting
        dispatch({ type: 'SIGNALR_REQUESTSTARTMEETING', payload: payload });

        // SignalR Listen to Recive Join Link for CMS Room  
        // @ts-ignore 
        const messagetypeRECIVEMESSAGELINK = "ReceiveMeetingLink"
        dispatch({ type: 'SIGNALR_RECIVEMEETINGLINK', eventName: messagetypeRECIVEMESSAGELINK });

        // SignalR Listen to Chached ID Austria Daten 
        // @ts-ignore 
        const messagetypeCashedIdAustriaData = "OnNotarJoinMeetingWithCashedIdAustriaData"
        dispatch({ type: 'SIGNALR_GETIDA_CACHE', eventName: messagetypeCashedIdAustriaData }); 
      }

   // eslint-disable-next-line react-hooks/exhaustive-deps
   },[dispatch, signalrconnected, token]);


   /**
    * Initializes the internationalization settings.
    */
   const initializeIntl = () => {
    // 2. Fallback to "de-DE" if the currentLocale isn't supported in LOCALES_LIST
    if (!LOCALES_LIST.some(item => item.value === currentLocale)) {
      currentLocale = "de_DE"
    }
    setCurrentLocale(currentLocale);
    localStorage.removeItem("savedTab");
    setInitDone(true);
  }

  /**
   * Set the current locale for internationalization.
   *
   * @param {string} currentLocale - The new locale to set.
   * @return {void} 
   */
  const setCurrentLocale = (currentLocale: string) => {
    intl.init({
      currentLocale,
      locales: LOCALE_DATA,
    });
  };

    if (!initDone){
      initializeIntl();
    } else {
      setCurrentLocale(currentLocale)
    }

    //console.log(signalrconnected)

  return (
    <>
    <Container fluid>
      {!signalrconnected && !signalrerror &&
          <Group position="center" className={classes.vcenter1}>
              <Loader size="120" variant="bars" color="gray"/>
          </Group>
      } 

      {!signalrconnected && signalrerror &&
          <Group position="center" className={classes.vcenter}>
              <Alert variant="filled" color="red" title={intl.get('CONNECTION_ERROR_HEADLINE')}icon={icon}>
               {intl.get('CONNECTION_ERROR_TEXT')}
            </Alert>
          </Group>
      }

    {iskicked &&
          <Group position="center" className={classes.vcenter}>
              <Alert variant="filled" color="red" title={intl.get('CLIENT_IS_KICKED_HEAD')}icon={icon}>
               {intl.get('CLIENT_IS_KICKED_TEXT')}
            </Alert>
          </Group>
      }

      {signalrconnected && !signalrerror && !isSetup &&
          <ClientSwitch />
      }

      {signalrconnected && !signalrerror && isSetup &&
          <SetupForDrn />
      }


        
</Container>

    </>
  );
}

export default App;
